export const DEFAULT = "DEFAULT";

/** The internal Signalist company; only its users can be flagged as support staff. */
export const SUPPORT_COMPANY_ID = 1;

/**
 * Version of the default leads/contacts table column layout (order + which columns are visible by
 * default). Bump this whenever the default column order or default visibility changes so that every
 * user's persisted column config is force-reset to the new defaults on their next load — otherwise a
 * saved config keeps the old layout forever (see PREC-3567). The tables persist this alongside their
 * column config and rebuild from defaults when the stored version is stale.
 */
export const COLUMN_CONFIG_VERSION = 2;
